import React from 'react'
import { PrismicRichText } from '@prismicio/react'

// Components
import Card from './card'

const CardDeck = ({ slice }) => {
  var grid = 'md:grid-cols-2 max-w-screen-md mx-auto'
  if (slice.items.length === 3) {
    grid = 'md:grid-cols-3 max-w-screen-xl mx-auto'
  }
  if (slice.items.length === 4) {
    grid = 'md:grid-cols-2 max-w-screen-md mx-auto'
  }
  return (
    <div className={`relative z-10 ${slice.primary.background === true ? 'bg-brand-lightest-blue' : 'bg-white'}`}>
      <section className='component-card_deck mx-auto w-full p-6'>
        <div className='prose mx-auto mb-6 max-w-screen-xl text-center md:prose-lg'>
          <PrismicRichText field={slice.primary.title?.richText} />
        </div>
        <ul className={`grid grid-cols-1 gap-3 ${grid}`}>
          {slice.items.map((card, index) => {
            return <Card fields={card} key={`card-${index}`} />
          })}
        </ul>
      </section>
    </div>
  )
}

export default CardDeck
